/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { node, oneOf, func, bool } from 'prop-types';
import classNames from 'clsx';

import Button from 'components/Button/Button';

import styles from './auth-button.scss';

import p from 'polyglot/polyglot';

import FacebookLogo from 'gfx/vector/facebook-logo.svg';
import GoogleLogo from 'gfx/vector/google-logo.svg';

const logos = {
  facebook: <FacebookLogo />,
  google: <GoogleLogo />,
};

/**
 * This is the AuthButton component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class AuthButton extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    type: oneOf(['facebook', 'google']).isRequired,
    onClick: func.isRequired,
    children: node.isRequired,
    disabled: bool,
    wide: bool,
    showIcon: bool,
  };

  static defaultProps = {
    disabled: false,
    wide: false,
    showIcon: true,
  };

  /**
   * Render AuthButton.
   *
   * @return {Object}
   */
  render() {
    const { children, type, disabled, wide, showIcon, onClick } = this.props;

    const buttonText = children === "Google" ? p.t('signup.authenticate.login-google') : p.t('signup.authenticate.login-facebook');

    const className = classNames(styles.button, {
      [styles.disabled]: disabled,
      [styles[type]]: true,
    });

    return (
      <Button wide={wide} className={className} onClick={onClick}>
        {showIcon && <span className={styles.icon}>{logos[type]}</span>}
        {buttonText}
      </Button>
    );
  }
}
